import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of, tap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ApiFilter, GetQueryParam} from '../../utilities/service';
import {AlertingApiKey, AlertingApiKeys, ApiKey, ApiToken, Storage_Token_Key} from '../../models/apiKey';
import {NotificationService} from '../notification/notification.service';
import {User} from '../../models/user';
import {DataService} from "../data/data.service";


@Injectable({
  providedIn: 'root'
})
export class SessionService {
  protected user: User;
  protected apiKey: string | undefined;

  public userChanged: EventEmitter<any> = new EventEmitter();
  public sessionExpired: EventEmitter<any> = new EventEmitter();

  constructor(public http: HttpClient, public notificationService: NotificationService, private dataService: DataService) {
  }

  emitTimeOut() {
    this.sessionExpired.emit();
  }

  clearUser(): void {
    this.user = undefined;
  }

  get() {
    return this.user;
  }

  getUserId(): string {
    return this.user ? this.user.username : undefined;
  }

  getUser(refresh?: boolean): Observable<User> {
    if (!refresh && this.user) {
      return of(this.user);
    }


      return this.dataService.getUserInfo().pipe(
        catchError((err) => {
          if (err.status === 403) {
            this.notificationService.dismissAll();
            return of({
              disabled: true
            } as User);
          }
          return throwError(err);
        }),
        tap((user) => {
            this.user = user;
            this.userChanged.emit(user);
        })
      );
  }

  getApiKeys(filter?: ApiFilter): Observable<AlertingApiKeys> {
    return this.http.get<AlertingApiKeys>(`/api/v1/tokens?${GetQueryParam(filter)}`);
  }

  getApiKey(id: string):  Observable<AlertingApiKey> {
    return this.http.get<AlertingApiKey>(`/api/v1/tokens/${id}`);
  }

  createApiKey(token: ApiKey): Observable<AlertingApiKey> {
    return this.http.post<AlertingApiKey>(`/api/v1/tokens`, token);
  }

  revokeApiKey(id: string):  Observable<AlertingApiKey> {
    return this.http.delete<AlertingApiKey>(`/api/v1/tokens/${id}`);
  }

    getXApiKey(): string | undefined {
        if (this.apiKey) {
            return this.apiKey;
        } else {
            const token_blob = localStorage.getItem(Storage_Token_Key);

            if (token_blob) {
                const token: ApiToken = JSON.parse(atob(token_blob));

                if (token.ttl >= Date.now()) {
                    this.apiKey = token.key;
                    return this.apiKey;
                } else {
                    localStorage.removeItem(Storage_Token_Key);
                    return undefined;
                }
            }
        }
        return undefined;
    }

  logout(): void {
      localStorage.removeItem(Storage_Token_Key);
      window.location.href = `${window.location.origin}/logout`;
  }
}
